import { useEffect } from 'react';
import { Outlet, useMatches, ScrollRestoration } from 'react-router';

const TitleLayout = () => {
    const matches = useMatches();

    useEffect(() => {
        const matchWithTitle = [...matches].reverse().find((m) => m.handle?.title);

        if (matchWithTitle) {
            document.title = `${matchWithTitle.handle.title} | Work World`;
        } else {
            document.title = 'Work World';
        }
    }, [matches]);

    return (
        <>
            <ScrollRestoration />
            <Outlet />
        </>
    );
};

export default TitleLayout;
